import { State_update, State_init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { singleton, ofArray, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Filter } from "../../../Kundenportal.Types.fs.js";
import { Page } from "./Types.fs.js";
import { parse } from "../../../fable_modules/fable-library-js.4.19.0/Int32.js";
import { int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(State_init, State_update, view, (_arg_1) => (new PageHeader(1, ["Auswertungen & Dokumente"])), (_arg_3) => (!isEmpty(_arg_3) ? ((head(_arg_3) === "files") ? (!isEmpty(tail(_arg_3)) ? ((head(tail(_arg_3)) === "page") ? (isEmpty(tail(tail(_arg_3))) ? (new Page(1, new Filter(2, [head(tail(_arg_3))]))) : (!isEmpty(tail(tail(tail(_arg_3)))) ? (isEmpty(tail(tail(tail(tail(_arg_3))))) ? ((head(tail(tail(_arg_3))) === "page") ? (new Page(parse(head(tail(tail(tail(_arg_3)))), 511, false, 32), new Filter(2, [head(tail(_arg_3))]))) : undefined) : undefined) : (new Page(parse(head(tail(tail(_arg_3))), 511, false, 32), new Filter(0, []))))) : ((head(tail(_arg_3)) === "new") ? (!isEmpty(tail(tail(_arg_3))) ? ((head(tail(tail(_arg_3))) === "page") ? (!isEmpty(tail(tail(tail(_arg_3)))) ? (isEmpty(tail(tail(tail(tail(_arg_3))))) ? (new Page(parse(head(tail(tail(tail(_arg_3)))), 511, false, 32), new Filter(1, []))) : undefined) : undefined) : undefined) : (new Page(1, new Filter(1, [])))) : (!isEmpty(tail(tail(_arg_3))) ? ((head(tail(tail(_arg_3))) === "page") ? (!isEmpty(tail(tail(tail(_arg_3)))) ? (isEmpty(tail(tail(tail(tail(_arg_3))))) ? (new Page(parse(head(tail(tail(tail(_arg_3)))), 511, false, 32), new Filter(2, [head(tail(_arg_3))]))) : undefined) : undefined) : undefined) : (new Page(1, new Filter(2, [head(tail(_arg_3))])))))) : (new Page(1, new Filter(0, [])))) : undefined) : undefined), (_arg_2) => {
    if (_arg_2.fields[0] === 1) {
        switch (_arg_2.fields[1].tag) {
            case 1:
                return ofArray(["files", "new"]);
            case 2:
                return ofArray(["files", _arg_2.fields[1].fields[0]]);
            default:
                return singleton("files");
        }
    }
    else {
        switch (_arg_2.fields[1].tag) {
            case 1:
                return ofArray(["files", "new", "page", int32ToString(_arg_2.fields[0])]);
            case 2:
                return ofArray(["files", _arg_2.fields[1].fields[0], "page", int32ToString(_arg_2.fields[0])]);
            default:
                return ofArray(["files", "page", int32ToString(_arg_2.fields[0])]);
        }
    }
}, (_arg) => {
    if (_arg.tag === 6) {
        return _arg.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=WebPart.fs.js.map
